export default (function (_ref) {
  var Vue = _ref.Vue;

  if (typeof navigator.geolocation.getCurrentPosition !== 'undefined') {
    Vue.prototype.$geolocation = navigator.geolocation;
  }
});